<template>
  <section class="home">
    <errors-alert
      v-bind:errors="errorsFromBackend"
      v-on:clear="clearAlert()"
    />
    <img src="/static/logo.png">
    <section class="embed-responsive embed-responsive-16by9">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8vRDnCZ_h1XsBar-k190Bs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </section>
    <hr>
    <section class="row">
      <section class="col-xs-4">
        <strong>14 day free trial</strong>
      </section>
      <section class="col-xs-4">
        <strong>$25 for the basic plan</strong>
      </section>
      <section class="col-xs-4">
        <strong>$75 for the premium plan</strong>
      </section>
    </section>
    <router-link to="/register"><button class="btn btn-primary btn-block btn-lg">Register</button></router-link>
    <hr>
    <!-- <section class="social-proof"></section>
    <hr> -->
    <!-- <section>
      <p>Six Plus Hold’em is software that poker players use to study with off the table.</p>
      <p>Using software to study is crucial. Whether it's Six Plus Hold’em or a different app like Flopzilla, any poker coach <a target="_blank" href="https://www.blackrain79.com/2018/08/best-poker-software.html">would</a> <a target="_blank" href="https://www.youtube.com/watch?v=81fQB62GlyM">emphatically</a> <a target="_blank" href="https://upswingpoker.com/poker-tools-apps-tournaments/">agree</a> <a target="_blank" href="http://www.thepokerbank.com/archives/software-types/">that</a> <a target="_blank" href="https://www.splitsuit.com/flopzilla">you</a> <a target="_blank" href="https://www.splitsuit.com/holdeq">need</a> <a target="_blank" href="https://www.splitsuit.com/learning-poker-for-new-players">software</a> if you're going to be a serious player.</p>
    </section> -->
    <div id="carousel" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner">
        <div class="item active">
          <img src="/static/carousel/10.png">
        </div>
        <div class="item">
          <img src="/static/carousel/11.png">
        </div>
        <div class="item">
          <img src="/static/carousel/12.png">
        </div>
        <div class="item">
          <img src="/static/carousel/1.png">
        </div>
        <div class="item">
          <img src="/static/carousel/2.png">
        </div>
        <div class="item">
          <img src="/static/carousel/8.png">
        </div>
        <div class="item">
          <img src="/static/carousel/9.png">
        </div>
        <div class="item">
          <img src="/static/carousel/3.png">
        </div>
        <div class="item">
          <img src="/static/carousel/4.png">
        </div>
        <div class="item">
          <img src="/static/carousel/5.png">
        </div>
        <div class="item">
          <img src="/static/carousel/6.png">
        </div>
        <div class="item">
          <img src="/static/carousel/7.png">
        </div>
        <div class="item">
          <img src="/static/carousel/13.png">
        </div>
        <div class="item">
          <img src="/static/carousel/14.png">
        </div>
        <div class="item">
          <img src="/static/carousel/15.png">
        </div>
      </div>
      <a class="left carousel-control" href="#carousel" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#carousel" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <hr>
    <p>Check out the quiz below to get more of a feel for what you can do with Six Plus Hold’em.</p>
    <section class="quiz well">
      <header>
        <h2 class="page-header">Quiz</h2>
      </header>
      <section class="question-container">
        <h3>1) How many folds will you get on a K84 rainbow board if you cbet and only get called by pairs and better?</h3>
        <section class="choices">
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[0].selection !== null,
              'selected': questions[0].selection === 0,
            }"
            v-on:click="submitAnswer(questions[0], 0)"
          >
            30%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[0].selection !== null,
              'selected': questions[0].selection === 1,
            }"
            v-on:click="submitAnswer(questions[0], 1)"
          >
            40%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[0].selection !== null,
              'selected': questions[0].selection === 2,
            }"
            v-on:click="submitAnswer(questions[0], 2)"
          >
            50%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[0].selection !== null,
              'selected': questions[0].selection === 3,
            }"
            v-on:click="submitAnswer(questions[0], 3)"
          >
            60%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[0].selection !== null,
              'selected': questions[0].selection === 4,
            }"
            v-on:click="submitAnswer(questions[0], 4)"
          >
            70%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[0].selection !== null,
              'selected': questions[0].selection === 5,
            }"
            v-on:click="submitAnswer(questions[0], 5)"
          >
            80%
          </button>
        </section>
        <section v-if="questions[0].selection !== null">
          <section v-if="questions[0].selection === questions[0].answer" class="alert alert-success">
            Correct! {{ currentScoreText }}
          </section>
          <section v-if="questions[0].selection !== questions[0].answer" class="alert alert-danger">
            Incorrect. The correct answer was 60%. {{ currentScoreText }}
          </section>
          <section class="well">
            <section class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/3bbXx2TQLGQ?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </section>
            <p>Let's assume that we open preflop and get called by a 25% range, where the bottom of the range includes stuff like A9o, 54s, and 96s, and we remove QQ+/AK from the top of the range. If we then assume that they'll only continue on the flop with pairs or better, we're going to be generating about 60% folds. That means that cbet bluffing will be super profitable!</p>
            <p>Of course, these assumptions won't always apply. Sometimes people will call with stuff like gutshots and AQ. Sometimes they'll check-raise as a bluff. Sometimes they'll enter the flop with a stronger range.</p>
            <p>This quiz question was just meant to wet your appetite. If you want to explore other scenarios, head over to the <router-link to="/register">register</router-link> page to get started with your <strong>14 day free trail</strong> (no credit card required).</p>
          </section>
        </section>
      </section>
      <section class="question-container">
        <h3>2) What if we change the board to KJ2shh and add in flush draws and straight draws?</h3>
        <section class="choices">
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[1].selection !== null,
              'selected': questions[1].selection === 0,
            }"
            v-on:click="submitAnswer(questions[1], 0)"
          >
            30%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[1].selection !== null,
              'selected': questions[1].selection === 1,
            }"
            v-on:click="submitAnswer(questions[1], 1)"
          >
            40%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[1].selection !== null,
              'selected': questions[1].selection === 2,
            }"
            v-on:click="submitAnswer(questions[1], 2)"
          >
            50%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[1].selection !== null,
              'selected': questions[1].selection === 3,
            }"
            v-on:click="submitAnswer(questions[1], 3)"
          >
            60%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[1].selection !== null,
              'selected': questions[1].selection === 4,
            }"
            v-on:click="submitAnswer(questions[1], 4)"
          >
            70%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[1].selection !== null,
              'selected': questions[1].selection === 5,
            }"
            v-on:click="submitAnswer(questions[1], 5)"
          >
            80%
          </button>
        </section>
        <section v-if="questions[1].selection !== null">
          <section v-if="questions[1].selection === questions[1].answer" class="alert alert-success">
            Correct! {{ currentScoreText }}
          </section>
          <section v-if="questions[1].selection !== questions[1].answer" class="alert alert-danger">
            Incorrect. The correct answer was 40%. {{ currentScoreText }}
          </section>
          <section class="well">
            <section class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/dNQsztMLAFE?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </section>
            <p>Let's assume that we open preflop and get called by a 25% range, where the bottom of the range includes stuff like A9o, 54s, and 96s, and we remove QQ+/AK from the top of the range. If we then assume that they'll only continue on the flop with pairs or better, flush draws, and open ended straight draws, we're going to be generating about 40% folds. That means that a cbet bluff will still usually be profitable, but not always.</p>
            <p>Of course, these assumptions won't always apply. Sometimes people will call with stuff like gutshots and AX. Sometimes they'll check-raise as a bluff. Sometimes they'll enter the flop with a stronger range.</p>
            <p>This quiz question was just meant to wet your appetite. If you want to explore other scenarios, head over to the <router-link to="/register">register</router-link> page to get started with your <strong>14 day free trail</strong> (no credit card required).</p>
          </section>
        </section>
      </section>
      <section class="question-container">
        <h3>3) Assume we get called on the flop in the previous question, and that the turn is a 4h, completing the flush draws. How many folds will you get if they only continue with top pair and better?</h3>
        <section class="choices">
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[2].selection !== null,
              'selected': questions[2].selection === 0,
            }"
            v-on:click="submitAnswer(questions[2], 0)"
          >
            30%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[2].selection !== null,
              'selected': questions[2].selection === 1,
            }"
            v-on:click="submitAnswer(questions[2], 1)"
          >
            40%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[2].selection !== null,
              'selected': questions[2].selection === 2,
            }"
            v-on:click="submitAnswer(questions[2], 2)"
          >
            50%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[2].selection !== null,
              'selected': questions[2].selection === 3,
            }"
            v-on:click="submitAnswer(questions[2], 3)"
          >
            60%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[2].selection !== null,
              'selected': questions[2].selection === 4,
            }"
            v-on:click="submitAnswer(questions[2], 4)"
          >
            70%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[2].selection !== null,
              'selected': questions[2].selection === 5,
            }"
            v-on:click="submitAnswer(questions[2], 5)"
          >
            80%
          </button>
        </section>
        <section v-if="questions[2].selection !== null">
          <section v-if="questions[2].selection === questions[2].answer" class="alert alert-success">
            Correct! {{ currentScoreText }}
          </section>
          <section v-if="questions[2].selection !== questions[2].answer" class="alert alert-danger">
            Incorrect. The correct answer was 60%. {{ currentScoreText }}
          </section>
          <section class="well">
            <section class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/jVXpVRpkFrs?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </section>
            <p>A lot of people are scared by the possible flush completing. They worry that their opponent called the flop with a lot of flush draws, and now all of those flush draws became flushes, which means it's time to give up.</p>
            <p>In reality, this fear is exaggerated. In fact, it can work to your advantage! Many of your opponents will have the same fears. They'll see the flush complete and want to get out of there with any mediocre hands. That means that you'll be able to generate a lot of folds.</p>
            <p>Of course, these assumptions won't always apply. This quiz question was just meant to wet your appetite. If you want to explore other scenarios, head over to the <router-link to="/register">register</router-link> page to get started with your <strong>14 day free trail</strong> (no credit card required).</p>
          </section>
        </section>
      </section>
      <section class="question-container">
        <h3>4) Can you ever get away from KK preflop?</h3>
        <section class="choices">
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[3].selection !== null,
            }"
            v-on:click="submitAnswer(questions[3], 0)"
          >
            Yes
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[3].selection !== null,
            }"
            v-on:click="submitAnswer(questions[3], 0)"
          >
            No
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[3].selection !== null,
            }"
            v-on:click="submitAnswer(questions[3], 0)"
          >
            Maybe
          </button>
        </section>
        <section v-if="questions[3].selection !== null">
          <section v-if="questions[3].selection === questions[3].answer" class="alert alert-success">
            All answers were considered to be correct here; this one was a freebie :) {{ currentScoreText }}
          </section>
          <section class="well">
            <section class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/NExb5KXxorM?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </section>
            <p>This was meant as a fun one. Please don't go around folding KK all the time and blaming me! Laying it down is very frequently going to be a big mistake.</p>
            <p>However, as the video demonstrates, <em>if</em> you're confident enough that their range is KK+ — that they don't even have QQ or AK — then you can go ahead and lay it down. Hey, some opponents really are that nitty.</p>
            <p>The reason I chose this question is because it demonstrates how to think probabilistically using weighted ranges. That skill will be important for many, many other parts of poker.</p>
            <p>Here it's just about how likely they have QQ or AK, so it was a good example to demonstrate how that sort of thinking works, but in other spots things get a little bit more involved. Nothing too crazy though! Six Plus Hold’em does a lot of the heavy lifting for you.</p>
            <p>If you want to explore other scenarios, head over to the <router-link to="/register">register</router-link> page to get started with your <strong>14 day free trail</strong> (no credit card required).</p>
          </section>
        </section>
      </section>
      <section class="question-container">
        <h3>5) What hands can you call a shove with when a short stack shoves for 20bb over your 2bb open, and is shoving A7+ and 44+?</h3>
        <section class="choices">
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[4].selection !== null,
              'selected': questions[4].selection === 0,
            }"
            v-on:click="submitAnswer(questions[4], 0)"
          >
            22+, A2+
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[4].selection !== null,
              'selected': questions[4].selection === 1,
            }"
            v-on:click="submitAnswer(questions[4], 1)"
          >
            44+, A7+
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[4].selection !== null,
              'selected': questions[4].selection === 2,
            }"
            v-on:click="submitAnswer(questions[4], 2)"
          >
            66+, AT+
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[4].selection !== null,
              'selected': questions[4].selection === 3,
            }"
            v-on:click="submitAnswer(questions[4], 3)"
          >
            77+, AJ+
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[4].selection !== null,
              'selected': questions[4].selection === 4,
            }"
            v-on:click="submitAnswer(questions[4], 4)"
          >
            88+, AQ+
          </button>
        </section>
        <section v-if="questions[4].selection !== null">
          <section v-if="questions[4].selection === questions[4].answer" class="alert alert-success">
            Correct! {{ currentScoreText }}
          </section>
          <section v-if="questions[4].selection !== questions[4].answer" class="alert alert-danger">
            Incorrect. The correct answer was "66+, AT+". {{ currentScoreText }}
          </section>
          <section class="well">
            <section class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/zmvxZ3A9ysA?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </section>
            <p>To answer this question, there are two things we need to do. 1) Figure out what our required equity is, and 2) figure out what hands meet that requirement.</p>
            <p>To figure out our required equity, we use the <code>risk / (risk + reward)</code> formula. We're risking 18bb to win 23.5bb, so we need about 43% equity to break even.</p>
            <p>To figure out what hands meet that requirement, we use the equity matrix tool (<router-link to="/help/equity-matrix">overview</router-link>), and find out that the answer is roughly 66+, AT+.</p>
            <p>If you want to explore other scenarios, head over to the <router-link to="/register">register</router-link> page to get started with your <strong>14 day free trail</strong> (no credit card required).</p>
          </section>
        </section>
      </section>
      <section class="question-container">
        <h3>6) What hands can you 3bet with for value if they open a 20% range and call your 3bet 75% of the time?</h3>
        <section class="choices">
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[5].selection !== null,
              'selected': questions[5].selection === 0,
            }"
            v-on:click="submitAnswer(questions[5], 0)"
          >
            88+, AJ+
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[5].selection !== null,
              'selected': questions[5].selection === 1,
            }"
            v-on:click="submitAnswer(questions[5], 1)"
          >
            TT+, AQ+
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[5].selection !== null,
              'selected': questions[5].selection === 2,
            }"
            v-on:click="submitAnswer(questions[5], 2)"
          >
            QQ+, AK
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[5].selection !== null,
              'selected': questions[5].selection === 3,
            }"
            v-on:click="submitAnswer(questions[5], 3)"
          >
            KK+
          </button>
        </section>
        <section v-if="questions[5].selection !== null">
          <section v-if="questions[5].selection === questions[5].answer" class="alert alert-success">
            Correct! {{ currentScoreText }}
          </section>
          <section v-if="questions[5].selection !== questions[5].answer" class="alert alert-danger">
            Incorrect. The correct answer was "88+, AJ+". {{ currentScoreText }}
          </section>
          <section class="well">
            <section class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/N-DBWNwc4VA?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </section>
            <p>To answer this question, we want to know how much equity we have against the range that they're going to continue with. If they open with the top 20% of hands and continue 75% of the time, we can probably reduce the 20% range to 15%, and then remove AA and KK assuming that they'd 4bet those hands.</p>
            <p>Then, we can head over to the equity matrix tool (<router-link to="/help/equity-matrix">overview</router-link>) and simulate to see how we're doing against that range. Hands that have over 50% equity are good candidates to 3bet with for value, although you'll also want to consider things like postflop playability and position.</p>
            <p>If you want to explore other scenarios, head over to the <router-link to="/register">register</router-link> page to get started with your <strong>14 day free trail</strong> (no credit card required).</p>
          </section>
        </section>
      </section>
      <section class="question-container">
        <h3>7) Can you 3bet bluff if they call your 3bet 60% of the time, and then continue vs cbets 40% of the time?</h3>
        <section class="choices">
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[6].selection !== null,
              'selected': questions[6].selection === 0,
            }"
            v-on:click="submitAnswer(questions[6], 0)"
          >
            Yes
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[6].selection !== null,
              'selected': questions[6].selection === 1,
            }"
            v-on:click="submitAnswer(questions[6], 1)"
          >
            No
          </button>
        </section>
        <section v-if="questions[6].selection !== null">
          <section v-if="questions[6].selection === questions[6].answer" class="alert alert-success">
            Correct! {{ currentScoreText }}
          </section>
          <section v-if="questions[6].selection !== questions[6].answer" class="alert alert-danger">
            Incorrect. The correct answer was "Yes". {{ currentScoreText }}
          </section>
          <section class="well">
            <section class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/systBflkFhI?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </section>
            <p>To answer this question, we need to use the 3bet-cbet explorer (<router-link to="/help/three-bet-cbet-explorer">overview</router-link>). You plug in a bunch of inputs, and it tells you the EV of taking a 3bet-cbet line. The inputs help you estimate how they respond to your 3bet, how often you get 4bet, how they respond to the cbet, and how often they pay you off when you happen to smash the flop.</p>
            <p>Generally, when they're only defending vs the follow-up cbet 40% of the time, the 3bet-cbet line will be pretty +EV.</p>
            <p>It does depend on the assumptions you make though. If you want to explore other scenarios, head over to the <router-link to="/register">register</router-link> page to get started with your <strong>14 day free trail</strong> (no credit card required).</p>
          </section>
        </section>
      </section>
      <section class="question-container">
        <h3>8) How often does a full pot bluff need to work on the turn when you have a flush draw and expect to get paid off on the river?</h3>
        <section class="choices">
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[7].selection !== null,
              'selected': questions[7].selection === 0,
            }"
            v-on:click="submitAnswer(questions[7], 0)"
          >
            30%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-success': questions[7].selection !== null,
              'selected': questions[7].selection === 1,
            }"
            v-on:click="submitAnswer(questions[7], 1)"
          >
            35%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[7].selection !== null,
              'selected': questions[7].selection === 2,
            }"
            v-on:click="submitAnswer(questions[7], 2)"
          >
            40%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[7].selection !== null,
              'selected': questions[7].selection === 3,
            }"
            v-on:click="submitAnswer(questions[7], 3)"
          >
            45%
          </button>
          <button
            class="btn btn-default"
            v-bind:class="{
              'btn-danger': questions[7].selection !== null,
              'selected': questions[7].selection === 3,
            }"
            v-on:click="submitAnswer(questions[7], 3)"
          >
            50%
          </button>
        </section>
        <section v-if="questions[7].selection !== null">
          <section v-if="questions[7].selection === questions[7].answer" class="alert alert-success">
            Correct! {{ currentScoreText }}
          </section>
          <section v-if="questions[7].selection !== questions[7].answer" class="alert alert-danger">
            Incorrect. The correct answer was 35%. {{ currentScoreText }}
          </section>
          <section class="well">
            <section class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/FIKtY5ScbJM?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </section>
            <p>Often times we use the <code>risk / (risk + reward)</code> formula to say that a full pot bluff needs to work 50% of the time, and a 1/2 pot bet needs to work 33% of the time.</p>
            <p>But that formula doesn't capture the whole story. What if we have outs? What if there are river cards that we have +EV bluffs on? The risk-reward formula doesn't take those things into account, but the breakeven percentage for bluffing the turn tool does (<router-link to="/help/breakeven-percentage-for-bluffing-the-turn">overview</router-link>). With that tool, we find that the 50% number drops down to about 35% when we have a flush draw and are betting full pot.</p>
            <p>If you want to explore other scenarios, head over to the <router-link to="/register">register</router-link> page to get started with your <strong>14 day free trail</strong> (no credit card required).</p>
          </section>
        </section>
      </section>
    </section>
    <section class="other-questions">
      <section>
        <h3>How else can you use Six Plus Hold’em to study?</h3>
        <p>Check out some of the demo videos in the playlist below:</p>
        <section class="embed-responsive embed-responsive-16by9">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8rhfjlwM7OFsq_1YDfJNCf" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </section>
      </section>
      <section>
        <h3>Are there any options for short deck?</h3>
        <p>Yes! There are short deck versions of the <router-link to="/short-deck/equity-calculator">equity calculator</router-link> and hit calculator.</p>
        <p>The equity calculator is free (I'm experimenting with monetizing via affiliate links), and the hit calculator is $150. Check out the <router-link to="/short-deck-pricing">short deck pricing page</router-link> for more information.</p>
      </section>
      <section>
        <h3>Where can you go if you want to learn more?</h3>
        <p>Check out the <router-link to="/faq">FAQ page</router-link>, the <router-link to="/help">help page</router-link>, and the <a href="https://www.youtube.com/channel/UCNrKf4FUAN6E8NoSDKV20Ng" target="_blank">YouTube channel</a>.</p>
        <p>Also, never hesitate to <router-link to="/contact">get in touch</router-link>!</p>
      </section>
    </section>
  </section>
</template>

<script>
import ErrorsAlert from '@/components/utilities/errors-alert';

export default {
  name: 'ppt-home',
  components: {
    'errors-alert': ErrorsAlert,
  },
  data: function () {
    return {
      errorsFromBackend: [],
      questions: [{
        selection: null,
        answer: 3,
      }, {
        selection: null,
        answer: 1,
      }, {
        selection: null,
        answer: 3,
      }, {
        selection: null,
        answer: 0,
      }, {
        selection: null,
        answer: 2,
      }, {
        selection: null,
        answer: 0,
      }, {
        selection: null,
        answer: 0,
      }, {
        selection: null,
        answer: 1,
      }],
    };
  },
  computed: {
    currentScoreText: function () {
      if (this.totalAnswers < this.questions.length) {
        return `You're ${this.correctAnswers} for ${this.totalAnswers} so far.`;
      }

      return `You finished ${this.correctAnswers} for ${this.totalAnswers}.`;
    },
    correctAnswers: function () {
      let correctAnswers = 0;

      this.questions.forEach(function (question) {
        if (question.selection === question.answer) {
          correctAnswers++;
        }
      });

      return correctAnswers;
    },
    totalAnswers: function () {
      let totalAnswers = 0;

      this.questions.forEach(function (question) {
        if (question.selection !== null) {
          totalAnswers++;
        }
      });

      return totalAnswers;
    },
  },
  created: function () {
    if (this.$route.query.error) {
      this.updateErrorsAlert();
    }
  },
  watch: {
    '$route': function (to, from) {
      if (this.$route.query.error) {
        this.updateErrorsAlert();
      }
    }
  },
  methods: {
    submitAnswer: function (question, answer) {
      if (question.selection !== null) {
        return; // only get one shot at answering
      }

      question.selection = answer;
    },
    clearAlert: function () {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
      this.$router.replace('/');
    },
    updateErrorsAlert: function () {
      if (this.$route.query.error === 'requires-basic-auth') {
        this.errorsFromBackend.push('This requires you to have purchased at least the basic version of the app, or be on your free trial.');
      } else if (this.$route.query.error === 'requires-premium-auth') {
        this.errorsFromBackend.push('This requires you to have purchased the premium version of the app, or be on your free trial.');
      } else if (this.$route.query.error === 'already-paid') {
        this.errorsFromBackend.push('You have already purchased the app.');
      } else if (this.$route.query.error === 'iff-basic-auth') {
        this.errorsFromBackend.push('This page is only accessible to those who purchased the basic version of the app and haven\'t upgraded to premium.');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .home {
    .form-group {
      label {
        font-weight: normal;
      }

      input.form-control {
        font-size: 18px;
      }
    }

    @media (min-width: 450px) {
      .input-group {
        width: 395px;
      }
    }

    .btn-block {
      margin-top: 20px;
    }

    .question-container {
      margin-bottom: 50px;
      .choices {
        display: flex;
        margin: 20px -5px;

        button {
          flex-grow: 1;
          margin: 0 5px;

          &.btn-danger, &.btn-success {
            cursor: not-allowed;
          }

          &.selected {
            font-weight: bold;
            text-decoration: underline;
          }
        }
      }

      .well p {
        margin-bottom: 20px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue